var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "../_snowpack/pkg/react.js";

function SvgIconBatteryUndefined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 2L16 6H0v12h2.8L0 20.5 1.3 22 21.7 3.5 20.4 2zM2 16V8h11.8L5 16H2zm19-9.8V18H8l2.2-2H19V8l2-1.8zm3 4v3.5c0 .7-.6 1.2-1.2 1.2H22V9h.8c.6 0 1.2.6 1.2 1.2z"
  })));
}

export default SvgIconBatteryUndefined;